import { render } from "./favourites.vue?vue&type=template&id=668ad6ac&scoped=true"
import script from "./favourites.vue?vue&type=script&lang=js"
export * from "./favourites.vue?vue&type=script&lang=js"

import "./favourites.vue?vue&type=style&index=0&id=668ad6ac&scoped=true&lang=css"

import exportComponent from "D:\\SphinxProjects\\VUE3\\Excel_Library_Frontend_Website\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668ad6ac"]])

export default __exports__